// extracted by mini-css-extract-plugin
export default {"container":"giftCards_container__AHxo3","wrapper":"giftCards_wrapper__HK5ze","main":"giftCards_main__wHri+","button":"giftCards_button__lDWFF"};